<script lang="ts" setup>
import { tpgIconError } from '@tpg/grammar-web-icons';
import { storeToRefs } from 'pinia';

import { GrammarModal } from '@nora-monorepo/grammar-ui';

import { useErrorModalStore } from '#ui-shared/components/modals/error-modal/error-modal-store';

const errorModalStore = useErrorModalStore();
const { closeModal } = errorModalStore;

const { isOpen, headerText, bodyText } = storeToRefs(errorModalStore);

function onCancelClick() {
  closeModal();
}
</script>

<template>
  <GrammarModal
    :is-open="isOpen"
    :label="headerText"
    :secondary-label="bodyText"
    :show-close-button="true"
    type="error"
    :icon-template="tpgIconError"
    @close="onCancelClick"
  />
</template>
